<template>
    <div>This is a fake component registered globally with non-scoped style in order to make it available everywhere.</div>
</template>

<style lang="scss">
    /*
    In order to make webpack happy, you need to override css.loadOptions property :
    ```
        css: {
            loaderOptions: {
            css: {
                url: false,
            }
            }
        },
    ```
    */
    @import 'primevue/resources/primevue.min';
</style>
